<template>
  <div class="wrap">
    <navigation-skip></navigation-skip>
    <shop-header></shop-header>
    <navigation-top></navigation-top>
    <router-view></router-view>
    <probability-footer></probability-footer>
    <shop-footer></shop-footer>
    <navigation-bottom></navigation-bottom>
    <form-search></form-search>
  </div>
</template>

<script>
import NavigationSkip from '@/views/base/NavigationSkip'
import ShopHeader from '@/views/base/ShopHeader'
import NavigationTop from '@/views/base/NavigationTop'
import ProbabilityFooter from '@/views/base/ProbabilityFooter'
import ShopFooter from '@/views/base/ShopFooter'
import NavigationBottom from '@/views/base/NavigationBottom'
import FormSearch from '@/views/base/FormSearch'

export default {
  components: {
    NavigationSkip,
    ShopHeader,
    NavigationTop,
    ProbabilityFooter,
    ShopFooter,
    NavigationBottom,
    FormSearch
  },
  data() {
    return {}
  },
  methods: {}
}
</script>
<style></style>
